import { useTranslation } from "react-i18next";

import BaseStepper from "@/components_v2/Stepper/BaseStepper";
import EmailStep from "./components/EmailStep";
import PersonalDetailsStep from "./components/PersonalDetailsStep";
import OpenAccountStep from "./components/OpenAccountStep";
import SubmissionConfirmation from "./components/SubmissionConfirmation";
import AccountCreatedConfirmation from "./components/AccountCreatedConfirmation";
import { APPLY_STEP, useApplyToJoin } from "./hooks/useApplyToJoin";
import { useOpenRegister } from "./hooks/useOpenRegister";

import "./styles.css";

const ApplyToJoin = () => {
  const { t } = useTranslation();
  const openRegister = useOpenRegister();
  const {
    currentStep,
    form,
    organizations,
    isOpenRegistration,
    result,
    isCheckingEmail,
    isSubmitting,
    handleNext,
    handleBack,
    handleSubmit,
  } = useApplyToJoin(openRegister.startOpenRegistration);

  const stepperItems = [
    { title: t("applications.labels.getStartedStep") },
    { title: t("applications.labels.personalDetailsStep") },
  ];

  if (result) {
    return <SubmissionConfirmation result={result} />;
  }

  if (openRegister.registeredEmail) {
    return <AccountCreatedConfirmation email={openRegister.registeredEmail} />;
  }

  const renderStep = () => {
    if (currentStep === APPLY_STEP.EMAIL) {
      return (
        <EmailStep
          form={form}
          isCheckingEmail={isCheckingEmail}
          handleNext={handleNext}
        />
      );
    }

    if (isOpenRegistration) {
      return (
        <OpenAccountStep
          form={openRegister.form}
          isSubmitting={openRegister.isSubmitting}
          handleBack={handleBack}
          handleSubmit={openRegister.handleSubmit}
        />
      );
    }

    return (
      <PersonalDetailsStep
        form={form}
        organizations={organizations}
        isSubmitting={isSubmitting}
        handleBack={handleBack}
        handleSubmit={handleSubmit}
      />
    );
  };

  return (
    <div className="apply-to-join full-width">
      <BaseStepper
        className="apply-to-join__stepper"
        current={currentStep}
        items={stepperItems}
      />

      {renderStep()}
    </div>
  );
};

export default ApplyToJoin;
